export class FormConfigurationError extends Error {
    constructor(m: string) {
        super(m);
        // Set the prototype explicitly.
        Object.setPrototypeOf(this, FormConfigurationError.prototype);
    }
}
